import React, { Component } from 'react';
import { Row, Button } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import String from '../../assets/Locales/teacher_locales'
import './deleteModal.css'

class DeleteComp extends Component {
    render() {
        return (
            <div className="delete-popup" style={{ left: '0' }}>
                <div className="white-delete">
                    <h5> {this.props.title} </h5>
                    <div id="deleteBtn">
                        <Button color="primary mx-1" onClick={() => this.props.Delete()} style={{ backgroundColor: "#B50000", backgroundImage: "none", borderColor: "#B50000" }}> {String.confirmBTN} </Button>
                        <Button color="primary" onClick={() => this.props.Cancel()}>{String.cancelBTN} </Button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        lang: state.lang.lang
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {

    }
    , dispatch
)
export default (connect(mapStateToProps, mapDispatchToProps)(DeleteComp));